import { RouteInfo } from './../../../components/sidebar/sidebar.component';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {
  DoctorTypeEnum,
  CouponUsageTypes,
} from 'src/app/enums/appointment-coupon-enums';
import { showNotification } from 'src/app/helpers/show-toast';
import { IAppointmentCoupon } from 'src/app/_interfaces/coupons/i-appointment-coupon';
import { CouponsService } from 'src/app/_services/coupons.service';
import { Router } from '@angular/router';
import { getActualDate } from 'src/app/helpers/get-actual-time';

@Component({
  selector: 'app-add-appointment-coupon',
  templateUrl: './add-appointment-coupon.component.html',
  styleUrls: ['./add-appointment-coupon.component.scss'],
})
export class AddAppointmentCouponComponent implements OnInit {
  pageTitle: string = 'Coupons';
  couponDomain: number = 1;
  addCouponForm: FormGroup;
  isSubmited: boolean = false;
  specialities = [];
  specialitiesIds: string = null;
  couponUsageTypes = CouponUsageTypes;
  doctorTypes = DoctorTypeEnum;
  fromMinDate: Date;
  toMinDate: Date;
  coupon: IAppointmentCoupon;

  constructor(
    private formBuilder: FormBuilder,
    private couponsService: CouponsService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.fromMinDate = new Date();
    this.toMinDate = new Date();
    this.fromMinDate.setDate(this.fromMinDate.getDate());
    this.toMinDate.setDate(this.toMinDate.getDate());
  }

  ngOnInit(): void {
    this.addCouponForm = this.formBuilder.group({
      enName: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)],
      ],
      arName: [
        null,
        [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)],
      ],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      discountPercentage: [
        null,
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ],
      ],
      ceiling: [null],
      usageType: [null, [Validators.required]],
      doctorType: [this.doctorTypes.All, [Validators.required]],
      specialities: [null],
    });

    this.getAllSpecialities();
  }

  getAllSpecialities() {
    this.couponsService.getAllSpecialities().subscribe((res) => {
      this.specialities = res?.data?.doctorSpecilaities;
    });
  }

  checkEndDate(startDate, endDate) {
    const couponStartDate = new Date(startDate);

    if (startDate > endDate) {
      endDate = new Date(couponStartDate.setDate(startDate.getDate()));
    }

    return endDate;
  }

  generateItemsIds(items, selectedItems, selectedItemsIds, idKey) {
    if (selectedItems?.length) {
      if (selectedItems.length == items.length) {
        selectedItemsIds = null;
      } else {
        selectedItemsIds = selectedItems.map((item) => item[idKey]).join(',');
      }
    }

    return selectedItemsIds;
  }

  generateCopounObject(couponFormValue) {
    let startDate = getActualDate(couponFormValue.startDate, 2, true);

    let endDate = this.checkEndDate(
      couponFormValue.startDate,
      couponFormValue.endDate
    );

    endDate = getActualDate(endDate, 2, true);

    this.coupon = {
      domainId: this.couponDomain,
      couponName: couponFormValue.enName,
      arCouponName: couponFormValue.arName,
      startDate: startDate,
      endDate: endDate,
      discountPercentage: couponFormValue.discountPercentage,
      ceiling: couponFormValue.ceiling,
      usageTypeId: Number(couponFormValue.usageType),
      doctorTypeId: Number(couponFormValue.doctorType),
      specialitiesIds: couponFormValue.specialities?.length
        ? this.generateItemsIds(
            this.specialities,
            couponFormValue.specialities,
            this.specialitiesIds,
            'id'
          )
        : null,
    };
  }

  onAddCouponSubmit() {
    this.isSubmited = true;

    this.generateCopounObject(this.addCouponForm.value);

    if (this.addCouponForm.valid) {


      this.couponsService.addCoupon(this.coupon).subscribe((res) => {

        showNotification(
          'success',
          `The coupon with code '${res['data']['couponCode']}' has been added`,
          this.toastr
        );
        this.router.navigateByUrl('coupons');
      });
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
